import { render, staticRenderFns } from "./RumahSakit.vue?vue&type=template&id=325c8886"
import script from "./RumahSakit.vue?vue&type=script&lang=js"
export * from "./RumahSakit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports